import React from "react";
import "./Footer.css";
import Analytics from "./Analytics";
function Footer() {
  const footerYear = new Date().getFullYear();

  return (
    <>
      {/* <div className='feedback-button'>
                <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                    Feedback
                </button>
            </div>                                               */}
      <div className="footer_container" tabIndex={0}>
        <p>
          © {footerYear} Accenture. All Rights Reserved. Accenture Confidential.
          For internal use only. Powered by Learning Experiences - L&TT, ATCI.
          <Analytics />
        </p>
        {/* <p>© 2023 Accenture. All Rights Reserved. Accenture Confidential. For internal use only. Powered by Learning Experiences - L&TT, ATCI.</p> */}
      </div>
    </>
  );
}

export default Footer;
